import { useApi } from '@utils/api'
import { API_ENDPOINTS } from '@utils/api-endpoints'
import { Guide } from './model-types/Product'

export const useProductGuides = (
  shopId: string,
): {
  guides: Guide[]
  isLoading: boolean
  isError: boolean
} => {
  const url = `${API_ENDPOINTS.GET_GUIDES(shopId)}/?limit=nolimit`
  const { data, isError, isLoading } = useApi(url)
  return {
    guides: data?.data,
    isLoading,
    isError,
  }
}
